import { productFamilyKey } from './product-family';
import type { SearchResult, DiscoverRecommendation } from './types';

/** FVE sidebar policy: independent recommendations, excluding current result families. */
export function sidebarRecommendationItems(recommendations: DiscoverRecommendation[], results: SearchResult[], limit=6): DiscoverRecommendation[] {
  const seen=new Set(results.map(productFamilyKey));
  return recommendations.filter(product=>{
    if(!product.productId || !product.productUrl || !/^(in_stock|instock|available)$/i.test(product.availability ?? '')) return false;
    const key=productFamilyKey(product);
    if(seen.has(key)) return false;
    seen.add(key);return true;
  }).slice(0,limit);
}
